import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;

//get funding history for all balances, including from subwallets.
export function makePayout(obj, username, freshRequest = false, otp = false){
  const url = `${BASE_URL}/securepayouts`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  const payload = {
    username: username,
    freshRequest: freshRequest,
    otp: otp,

    source: obj.source,
    type: obj.type,
    sender_name: obj.sender,
    amount: obj.amount,
    wallet:{
      password: obj.wallet.password,
      currency:obj.wallet.currency,
      country: obj.wallet.country,
    },
    account_bank_code: obj.accountBankCode,
    account_number: obj.accountNumber,
    account_name: obj.accountName,
    narration: obj.narration,
    ref: obj.reference,
    branchCode: obj.branchCode,
    x_recipient_name: obj.accountName || obj.custom_recipientname,
    x_recipient_address: obj.recipientAddress,
    x_recipient_email: obj.custom_recipientemail,
    x_recipient_phone: obj.custom_recipientphone,
    x_swift_code: obj.custom_swiftcode,
    x_sender_name: obj.custom_sendername,
    x_sender_email: obj.custom_senderemail,
    x_sender_phone: obj.custom_senderphone,
    x_sender_address: obj.custom_senderaddress,
    x_sender_location: obj.custom_senderlocation,
    x_sender_country: obj.custom_sendercountry,
    x_question: obj.custom_question,
    x_answer: obj.custom_answer,
    x_transfer_type: obj.custom_transfertype,
    x_sender_id_type: obj.custom_senderidtype,
    x_sender_id_number: obj.custom_senderidnumber,
    x_sender_nationality: obj.custom_sendernationality,
    x_sender_source_of_funds: obj.custom_sendersourceoffunds,
    x_sender_dob: obj.custom_senderdob,
    x_senderOccupation: obj.custom_senderoccupation,
    x_sender_occupation: obj.custom_senderoccupation,
    custid: obj.custom_recipientphone
  };

  for (const x in obj) {
    if (x.includes('custom_')) {
      payload[x] = obj[x];
    }
  }

  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data: payload,
    // paramsSerializer: filter => Qs.stringify(filter, {arrayFormat: 'bracket'})
  })

}

export function resolveBulk(csv, currency) {
  const url = `${BASE_URL}/resolve/bulk`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  let formData = new FormData();
  let ext = (csv.name).substring((csv.name).lastIndexOf('.'));
  if(ext === ".csv"){
    formData.append('csv', new Blob([csv], {type: "text/csv"}));
  }
  
  formData.set('currency', currency)
  return axios.post(url, formData, {headers: { 'Content-Type': 'multipart/form-data',
      'Authorization': token,
      'merchant-id': merchantId }
  });
}

export function disburseQueue(dataObj){
  const url = `${BASE_URL}/disburse/bulk`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data: {
      recipients: dataObj.recipients,
      lock: dataObj.lockCode,
      currency: dataObj.currency,
      senderName: dataObj.sender,
      ref: dataObj.ref,
      name: dataObj.batchName,
      walletUref: dataObj.walletUref,
    }
  });

}

export function retryPayout(id, type, lockCode){
  const url = `${BASE_URL}/payouts/retry`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data: {
      transactionId: id,
      type: type,
      lockCode: lockCode,
    }
  });

}

//get disbursement history for a wallet.
export function getTransfers(perPage = 10, page = 1, para = {}, download = 0){
  console.log(para);
  const url = `${BASE_URL}/payouts`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params:{
      per_page:perPage,
      page:page,
      status: para.status,
      currency: para.currency,
      accountNumber: para.accountNumber,
      flutterReference: para.flutterReference,
      createdAt:
      { 
        from: para.createdAt.from,
        to: para.createdAt.to 
      },
      system_type: para.system_type,
      merchantId: para.merchantId || merchantId,
      download: download,
      loadReport: para.loadReport,
      dest: para.dest,
      system_type: para.system_type,
      terminalId: para.terminalId,
      amount: para.amount,
    }
  });

}

export function getDispenseErrors(perPage = 10, page = 1, param = {}, download = 0) {
  const url = `${BASE_URL}/pos/agent/${param.merchantId}/dispense/error`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');

  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params:{
      per_page: perPage,
      page: page,
      status: param.status,
      currency: param.currency || 'NGN',
      ref: param.ref,
      source: param.source,
      createdAt:
      { 
        from: param.createdAt.from,
        to: param.createdAt.to 
      },
      download: download,
    }
  });
}

export function logTransfer(data) {
  const url = `${BASE_URL}/pos/agent/${data.merchantId}/dispense/error`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data: {
      txref: data.txref,
      link: data.link,
    }
  });
}

export function getMerchantsTerminals(perPage = 10, page = 1, para = {}, download = 0) {
  const url = `${BASE_URL}/payouts/terminals`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params:{
      per_page:perPage,
      page:page,
      currency: para.currency,
      createdAt:
      { 
        from: para.createdAt.from,
        to: para.createdAt.to 
      },
      merchantId: para.merchantId || merchantId,
      download: download,
      terminalId: para.terminalId,
      type: para.type,
    }
  });
}

export function getBanksList(country, download=0) {
  const url = `${BASE_URL}/batch/bank/list`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params:{
      country: country,
      download: download,
    }
  });
}

export function getCurrencyName() {
  const url = `${BASE_URL}/batch/bank/name`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    }
  });
}

//get disbursement history for a wallet.
export function getTranferDetails(transferID){
  const url = `${BASE_URL}/payouts/detail`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      id: transferID,
    }
  })
}

export function getTranferDetailsViaRef(ref, transferID){
  const url = `${BASE_URL}/payouts/detail`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      id: transferID,
      ref: ref,
    }
  })
}

export function getMerchantsAgents(perPage = 10, page = 1, data = {}, download) {
  let merchantId = window.localStorage.getItem('merchantId');
  const url = `${BASE_URL}/merchants/${data.merchantId || merchantId}/agents`;
  let token = getCookie('token');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    }, 
    params:{
      per_page:perPage,
      page:page,
      download: download,
      currency: data.currency,
      createdAt:
      { 
        from: data.createdAt.from,
        to: data.createdAt.to 
      },
      merchantId: data.merchantId || merchantId,
    }
  });
}

export function retryPosCallback(ref) {
  let merchantId = window.localStorage.getItem('merchantId');
  const url = `${BASE_URL}/pos/callback`;
  let token = getCookie('token');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    }, 
    data:{
      ref,
    }
  });
}

export function sendReceipts(transferID, email, type){
  const url = `${BASE_URL}/payouts/detail/mail`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      transactionId: transferID,
      email: email,
      type: type
    }
  })

}



// WEBPACK FOOTER //
// ./src/utils/wallet-transactions/transferService.js